import { render, staticRenderFns } from "./NbMaxRows.vue?vue&type=template&id=4cbaf8da&scoped=true&"
import script from "./NbMaxRows.vue?vue&type=script&lang=js&"
export * from "./NbMaxRows.vue?vue&type=script&lang=js&"
import style0 from "./NbMaxRows.vue?vue&type=style&index=0&id=4cbaf8da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbaf8da",
  null
  
)

export default component.exports